<div [@dialog] class="dialog">
  
    <ng-content></ng-content>
    <button
        *ngIf="closable"
        (click)="close()"
        aria-label="Close"
        type="button"
        data-dismiss="modal"
        class="dialog__close-btn close">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="overlay" (click)="close()"></div>
